import { PageHeader } from "../components/PageHeader";
import { useSiteContent, resolveImageUrl } from "../context/ContentContext";
import Icon from "../components/Icon";

export default function Quality() {
  const { content } = useSiteContent();
  const { quality_blocks, images, quality_page } = content;
  const pageCopy = quality_page || {};

  return (
    <>
      <PageHeader
        eyebrow={pageCopy.header_eyebrow}
        title={
          <>
            {pageCopy.header_title_part1} <span className="theme-text-accent">{pageCopy.header_title_highlight}</span>
            {pageCopy.header_title_part2}
          </>
        }
        intro={pageCopy.header_intro}
      />

      <section className="section-pad">
        <div className="container-x grid lg:grid-cols-2 gap-12 items-start">
          <div className="grid sm:grid-cols-2 gap-5">
            {quality_blocks.map((b, i) => (
              <div key={i} className="card-soft p-6" data-testid={`quality-block-${i}`}>
                <div className="w-12 h-12 rounded-2xl theme-icon-chip flex items-center justify-center mb-5">
                  <Icon name={b.icon} className="w-5 h-5" />
                </div>
                <h3 className="font-display text-xl font-bold theme-text-primary mb-2">{b.title}</h3>
                <p className="theme-text-secondary text-sm leading-relaxed">{b.text}</p>
              </div>
            ))}
          </div>
          <div className="aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl">
            <img src={resolveImageUrl(images.refinery)} alt="Refinery" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>
    </>
  );
}
